import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { routes } from '../../../../constants/routes';
import { PDF_LINKS } from '../../../../constants/workshop-pdf-link';
@Component({
  selector: 'app-banner',
  standalone: true,
  imports: [],
  templateUrl: './banner.component.html',
  styleUrl: './banner.component.scss'
})
export class BannerComponent {
  readonly PDF_LINKS = PDF_LINKS;
  heroContent = {
    proposalIcon: 'images/proposal.svg',
    personImage: 'images/person.svg'
  };
  constructor(private router: Router) { }

  navigateToRegister() {
    this.router.navigate([`/${routes.workshop}/${routes.register_university}`])
  }
  navigateToPDFLink(): void {
    window.open(this.PDF_LINKS.WORKSHOP, '_blank');
  }

}